<template>
  <div class="serive">
    <div class="serivehtml">
      <div class="headtxt">
        <div class="head">
          <ResTxt
            id="e093ae6de4624"
            style="
              font-size: 18px;
              color: #275479;
              font-weight: bold;
              line-height: 30px;
            "
          />
          <br>
          <ResTxt 
            id="44610a0863292"
            style="
              font-size: 15px;
              color: #000000;
              line-height: 26px;
              letter-spacing: 1px;
              z-index: 11;
            "
          />
          <!-- <p
            style="
              font-size: 18px;
              color: #275479;
              font-weight: bold;
              line-height: 30px;
            "
          >
            服务渠道
          </p>

          <p
            style="
              font-size: 15px;
              color: #000000;
              line-height: 26px;
              letter-spacing: 1px;
            "
          >
            咨询软件使用方法，反馈软件的问题或对软件功能有什么建议，请按照以下渠道寻求帮助
          </p> -->
        </div>
      </div>
      <div class="bodycss">
        <div class="title">
          <p class="tiao1"></p>
          <!-- <p class="tiao2">论坛提问</p> -->
          <ResTxt class="tiao2" id="59ea907e8128d" style="text-indent: 80px"/>
          <p class="tiao3">渠道一</p>
        </div>
        <ul class="text" style="margin-right: 75px">
          <li>
            <div class="square"></div>
            <!-- 论坛是文华服务用户的主流渠道。 -->
            <ResTxt style="width: auto;" id="91c995e2b7d41" />
          </li>
          <li>
            <div class="square"></div>
            <!-- 论坛配备一支专业金融工程师团队，每日14个小时的在线值守，解答投资者提出的各种软件使用问题。 -->
            <ResTxt style="width: auto;" id="9fe9c32f8e397" />
          </li>
          <li style="text-indent: -1.5em; margin-left: 1.5em">
            <div class="square"></div>
            <!-- wh6/随身行/wh10相关问题30分钟内回复、wh7/wh8/wh9相关问题10分钟内回复，每天我们处理上千个用户的帖子，上一个年度我们解答了122040个用户的问题。 -->
            <ResTxt style="width: auto;text-indent: 0;vertical-align: top;" id="03815bc59abb3" />
            <!-- 保证15分钟内的回复速度，每天我们处理上千个用户的帖子，上一个年度我们解答了122040个用户的问题。 -->
          </li>
          <li>
            <div class="square"></div>
            <!-- 金融工程师团队成员，由具有金融类本科学历、持有期货从业资格证的专业人员组成。 -->
            <ResTxt style="width: auto;" id="ae1ad8fa4e611" />
          </li>
        </ul>
        <ResTxt
          id="d4abfad5c4b60"
          style="
            margin-left: 75px;
            color: #214078;
            font-size: 15px;
            margin-top: 25px;
            margin-bottom: 60px;
            letter-spacing: 1px;
          "
        />
        <!-- <p
          style="
            margin-left: 75px;
            color: #214078;
            font-size: 15px;
            margin-top: 50px;
            margin-bottom: 60px;
            letter-spacing: 1px;
          "
        >
          论坛入口：软件界面的右上角菜单，[帮助]－>论坛提问
        </p> -->
        <div class="title">
          <p class="tiao1"></p>
          <!-- <p class="tiao2">
            <span style="margin-left: 24px">Call_Center</span>
          </p> -->
          <ResTxt class="tiao2" style="text-indent: 80px" id="4696d591bf76a" />
          <p class="tiao3">渠道二</p>
        </div>
        <ul class="text">
          <li>
            <div class="square"></div>
            <ResTxt style="width: auto;" id="75b555399fc2a" />
            <!-- 呼叫中心配备一支金融工程师团队，接听用户电话，解决用户问题。 -->
          </li>
          <li>
            <div class="square"></div>
            <ResTxt style="width: auto;" id="aa4c3c9e7c6e9" />
            <!-- 金融工程师团队成员，由具有金融类本科学历、持有期货从业资格证的专业人员组成。 -->
          </li>
        </ul>
                <ResTxt
          id="f81a997fa7c0b"
          style="
            margin-left: 75px;
            color: #8d6a33;
            font-size: 19px;
            font-weight: bold;
            margin-top:25px;
          "
        />
        <br>
        <ResTxt
          id="ef12eb4c1288e"
          style="
            margin-left: 75px;
            color: #b6b6b6;
            font-size: 12px;
            letter-spacing: 1px;
            margin-bottom:60px
          "
        />
        <div class="title">
          <p class="tiao1"></p>
          <!-- <p class="tiao2">
            <span style="margin-left: 24px">Call_Center</span>
          </p> -->
          <div class="tiao2" style="text-indent: 80px" id="4696d591bf76a">小课堂</div>
          <p class="tiao3">渠道三</p>
        </div>
        <ul class="text" style="padding-bottom:30px">
          <div class="mode" style="height: 220px;">
            <div class="mCon mcon3">
              <div class="modThree">
                        <div style="text-indent: 2em;">小课堂，作为文华财经持续多年线下培训的直播版本，由研究部的资深金融工程师进行授课。</div>
                        <div style="text-indent: 2em;">小课堂的课程，从软件工具的角度出发，扩展到大宗商品的估值数据、用估值线提高交易决策正确率等投资策略层面，旨在帮助客户提高交易能力。</div>
                        <!-- <div style="text-indent: 2em;">每周二、四15:30，文华财经小课堂准时开播。</div> -->
              </div>
                     <div class="goIn" style="color: rgb(33, 64, 120); font-size: 15px;margin-top: 25px;">直播入口：软件界面的右上角菜单，[帮助]－>小课堂</div>
                     <div class="goIn" style="color: rgb(33, 64, 120); font-size: 15px;">每次直播后一周内，可以通过直播入口，看上一次的直播回放。</div>
            <!-- <div class="goIn" style="font-weight:bold;margin-top: 20px;">
            <span style="display:block;height:3px"></span>
            <img src="../../assets/images/saoma2.png" style="margin-left:26px;width:70px"><span style="position: relative;top: -58px;margin-left:108px;display:block;font-weight: normal;">  扫码关注"文华财经小课堂"视频号观看往期内容的视频回放。
</span></div> -->
		</div>
          </div>
        </ul>
        <!-- <p
          style="
            margin-left: 75px;
            color: #8d6a33;
            font-size: 19px;
            margin-top: 35px;
            font-weight: bold;
          "
        >
          400-811-3366
        </p>
        <p
          style="
            margin-left: 75px;
            color: #b6b6b6;
            font-size: 12px;
            letter-spacing: 1px;
          "
        >
          （工作日8:00～22:00，五一、十一、春节初三至初六16:30～20:30）
        </p> -->
      </div>
    </div>
    <wh7footer></wh7footer>
  </div>
</template>

<script>
import wh7footer from "./components/wh7/wh7footer.vue";
import ResTxt from '@/ResData/ResTxt'
import axios from "axios";
export default {
  components: {
    wh7footer,
    ResTxt
  },
  data(){
    return {
      url:'',
    }
  },
    created(){
      axios.get('https://wh-api.wenhua.com.cn/api/officemanage/smallclassurllist',{params:{type:'pc'}}).then(res=>{
                      var _hmt = _hmt || [];
                      (function() {
                      var hm = document.createElement("script");
                      hm.src = "https://hm.baidu.com/hm.js?f25789e3cde6e4f89ed3dc51e5ff7767";
                      var s = document.getElementsByTagName("script")[0]; 
                      s.parentNode.insertBefore(hm, s);
                      })();
                      var dat = res.data
                      var date=new Date()
                      var day=date.getDay()
                      console.log(dat)
                      if(day==5){
                      this.url=dat[5].url
                      }
                      else if(day==2){
                      this.url=dat[2].url
                      }
                      else if(day==3){
                      this.url=dat[3].url
                      }
                      else if(day==4){
                      this.url=dat[4].url
                      }
                      else if(day==1){
                      this.url=dat[1].url
                      }
                      else if(day==6){
                      this.url=dat[6].url
                      }
                      else{
                      this.url=dat[0].url
                      }
            })
    },
};
</script>

<style scoped>
.serivehtml {
  background:url("../../assets/images/fwqd-bg.jpg") no-repeat , url("../../assets/images/fwqd-bg2.jpg") no-repeat;
  background-position: top center,center 700px;
  background-size: auto , 1920px 100%;
  /* height: 839px; */
  min-width: 1400px;
  width: 100%;
  padding-bottom: 34px;
}
.headtxt {
  position: relative;
  height: 160px;
  width: 1000px;
  margin: 0 auto;
}
.head {
  position: absolute;
  top: 100px;
}
.bodycss {
  bottom: 0;
  width: 1005px;
  margin: 0 auto;
  /* height: 635px; */
  background: white;
  
}
.title {
  position: relative;

  height: 45px;
}
.tiao1 {
  position: absolute;
  background: url("../../assets/images/tiao1.jpg") no-repeat;
  width: 1005px;
  height: 35px;
  letter-spacing: 1px;
}
.tiao2 {
  position: absolute;
  background: url("../../assets/images/tiao2.jpg");
  width: 230px;
  height: 40px;
  text-align: left;
  color: white;
  font-size: 17px;
  line-height: 40px;
  letter-spacing: 1px;
}
.tiao3 {
  position: absolute;
  background: url("../../assets/images/tiao3.jpg");
  width: 60px;
  height: 40px;
  top: 5px;
  text-align: center;
  font-size: 14px;
  line-height: 40px;
  font-weight: bold;
  letter-spacing: 1px;
  z-index: 10;
}
.square {
  height: 8px;
  width: 8px;
  background: #1f4075;
  display: inline-block;
  margin-right: 12px;
  letter-spacing: 1px;
}
.text {
  margin-top: 15px;
  margin-left: 75px;
  line-height: 37px;
  color: #636363;
  font-size: 15px;
}



.mode {
    width: 100%;
    /* overflow: hidden; */
    /* background: #f5f5f5; */
    margin-bottom: 25px;
    height: 275px;
    position: relative;
    /* border-radius: 25px 0 0 0; */
}

.mode .myQuant {
    font-size: 16px;
    color: #555;
}

.mt {
    /* width: 100%;
    overflow: hidden; */
    /* border-left: 4px solid #02306e; */
    border-radius: 15px 0 0 0;
    background: #e0e7fa;
    font-weight: 700;
    line-height: 40px;
    font-size: 16px;
    padding-left: 28px;
    color: #253f62;
}

.modeNm {
    width: 70px;
    height: 50px;
    text-align: center;
    font-size: 17px;
    
    /*background: #3a84ff;*/
}

.modeTil {
    font-size: 17px;
    width: 760px;
    margin-left: 12px;
}

/* .mCon {
    width: 570px;
} */


.mcon3 {
    margin-top: 22px;
    margin-left: -11px;
}

.mcon4 {
    margin-top: 30px;
}

.mCon div {
    font-size: 15px;
    color: #636363;
    line-height: 25px;
    margin-right: 75px;
}

.modThree {
    width: 100%;
    margin: 15px 0;
}

.mtTit {
    font-size: 15px;
    font-weight: 700;
    line-height: 25px;
    color: #636363;
}




</style>